export enum eTypePackage {
  Unidad = 1,
  Caja = 2,
  Pack = 3,
  Pallet =4
}
